import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAddressFullName } from '../Utils';

export const ClientDetails = (props) => {
  const [open, setOpen] = useState(false);
  const buyerSpec = useRef(null);
  const buyerSpecProperty = useRef(null);
  const navigate = useNavigate();

  const handleBuyerSpecRegistered = () => {
    const options = {
      method: 'GET',
      url: `/buyer/getbuyerrequirements/${buyerSpec.current.dataset.buyerId}`,
    };

    axios
      .request(options)
      .then((response) => {
        // eslint-disable-next-line eqeqeq
        if (response.status === 200 || response.status === 201) {
          let commercialOrResidential =
            response?.data[0]?.commercialOrResidential === false
              ? { Residential: 'false' }
              : { Commercial: 'true' };
          let saleOrLetting =
            response?.data[0]?.saleOrLetting === false
              ? { ForSale: 'false' }
              : { ToLet: 'true' };
          let clientSpec = {
            buyerSpecId: response?.data[0]?.id,
            buyerId: response?.data[0]?.buyerId,
            buyerSpecName: response?.data[0]?.buyerSpecName,
            buyerSpecRef: response?.data[0]?.buyerSpecRef,
            geoRegionId: response?.data[0]?.geoRegionId,
            localityId:
              response?.data[0]?.buyerLocalities[0]?.localityId,
            zoneId: response?.data[0]?.buyerLocalities[0]?.zoneId,
            budgetMin:
              response?.data[0]?.buyerPropertyTypes[0]?.priceFrom,
            budgetMax:
              response?.data[0]?.buyerPropertyTypes[0]?.priceTo,
            propertyTypeGroupId:
              response?.data[0]?.buyerPropertyTypes[0]
                ?.propertyTypeGroupId,
            propertyTypeId:
              response?.data[0]?.buyerPropertyTypes[0]
                ?.propertyTypeId,
            propertySubTypeId:
              response?.data[0]?.buyerPropertyTypes[0]
                ?.propertySubTypeId,
            ...commercialOrResidential,
            ...saleOrLetting,
          };

          navigate('/PropertySearch', {
            state: {
              clientSpec: {
                ...clientSpec,
              },
            },
          });
        }
      })
      .catch(() => {
        toast.error(`Sorry, server error, try again later`, {
          position: 'top-left',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const handleMobileRegistered = (mobile) => {
    let mobileNumber = parseInt(mobile, 10);
    return `https://wa.me/${mobileNumber}`;
  };

  const handleMobileUnregistered = (mobile) => {
    let mobileNumber = parseInt(mobile, 10);
    return `https://wa.me/356${mobileNumber}`;
  };

  const handleBuyerSpecUnregistered = () => {
    const options = {
      method: 'GET',
      url: `/buyerspec/getviewmodel/${buyerSpec.current.dataset.buyerSpecId}`,
    };

    axios
      .request(options)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          let commercialOrResidential =
            response?.data?.buyerSpec?.commercialOrResidential ===
            false
              ? { Residential: 'false' }
              : { Commercial: 'true' };
          let saleOrLetting =
            response?.data?.buyerSpec?.saleOrLetting === false
              ? { ForSale: 'false' }
              : { ToLet: 'true' };
          let clientSpec = {
            buyerSpecName: response?.data?.buyerSpec?.buyerSpecName,
            buyerSpecRef: response?.data?.buyerSpec?.buyerSpecRef,
            geoRegionId: response?.data?.buyerSpec?.geoRegionId,
            localityId:
              response?.data?.buyerSpec?.buyerLocalities[0]
                ?.localityId,
            zoneId:
              response?.data?.buyerSpec?.buyerLocalities[0]?.zoneId,
            budgetMin:
              response?.data?.buyerSpec?.buyerPropertyTypes[0]
                ?.priceFrom,
            budgetMax:
              response?.data?.buyerSpec?.buyerPropertyTypes[0]
                ?.priceTo,
            propertyTypeGroupId:
              response?.data?.buyerSpec?.buyerPropertyTypes[0]
                ?.propertyTypeGroupId,
            propertyTypeId:
              response?.data?.buyerSpec?.buyerPropertyTypes[0]
                ?.propertyTypeId,
            propertySubTypeId:
              response?.data?.buyerSpec?.buyerPropertyTypes[0]
                ?.propertySubTypeId,
            ...commercialOrResidential,
            ...saleOrLetting,
          };

          navigate('/PropertySearch', {
            state: {
              clientSpec: {
                ...clientSpec,
              },
            },
          });
        }
      })
      .catch(() => {
        toast.error(`Sorry, server error, try again later`, {
          position: 'top-left',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const handleBuyerProperties = () => {
    // Navigate immediately and let BuyerProperties handle paged loading
    navigate('/BuyerProperties', {
      state: {
        buyerName: buyerSpecProperty.current.dataset.buyerName,
        buyerRef: buyerSpecProperty.current.dataset.buyerRef,
        buyerSpecId: buyerSpecProperty.current.dataset.buyerSpecId,
        buyerEmail: buyerSpecProperty.current.dataset.buyerEmail,
      },
    });
  };

  return (
    <div>
      <div
        onClick={() => setOpen(!open)}
        className="pb-2 d-flex justify-content-between"
      >
        <div className="font-weight-bold cursor-item">
          {
            props?.contact?.contact?.address
              ?.addressIndividualFirstName
          }{' '}
          <span className="font-weight-bold">
            {
              props?.contact?.contact?.address
                ?.addressIndividualSurname
            }
            {props?.contact?.contact?.address?.addressOrganisationName}
            {props?.contact?.contact?.buyerSpec?.buyerSpecName}
          </span>
        </div>
        <small>Buyer Ref: {props?.contact?.contact?.buyerRef}</small>
      </div>
      {open ? (
        <div className="border-bottom d-flex">
          {props?.contact?.contact?.address?.addressPhones[0]
            ?.telephoneNo && (
            <a
              href={`tel:${props?.contact?.contact?.address?.addressPhones[0]?.prefix}${props?.contact?.contact?.address?.addressPhones[0]?.telephoneNo}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-phone fa-2x mr-4 mb-2 cursor-item"></i>
            </a>
          )}
          {props?.contact?.contact?.buyerSpec?.phoneNo && (
            <a
              href={`tel:+356${props?.contact?.contact?.buyerSpec?.phoneNo}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-phone fa-2x mr-4 mb-2 cursor-item"></i>
            </a>
          )}
          {props?.contact?.contact?.address !== null &&
           props?.contact?.contact?.address?.addressEmails[0]?.emailAddress !== undefined ? (
            <a
              href={`mailto: ${props?.contact?.contact?.address?.addressEmails[0]?.emailAddress}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="far fa-paper-plane fa-2x mr-4 mb-2 cursor-item"></i>
            </a>
          ) : null}
          {props?.contact?.contact?.buyerSpec !== null &&
          props?.contact?.contact?.buyerSpec?.email !== null ? (
            <a
              href={`mailto: ${props?.contact?.contact?.buyerSpec?.email}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="far fa-paper-plane fa-2x mr-4 mb-2 cursor-item"></i>
            </a>
          ) : null}
          {props?.contact?.contact?.address?.addressPhones[0]
            ?.telephoneNo && (
            <a
              href={handleMobileRegistered(
                `${props?.contact?.contact?.address?.addressPhones[0]?.prefix}${props?.contact?.contact?.address?.addressPhones[0]?.telephoneNo}`,
              )}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-whatsapp fa-2x mr-4 mb-2 cursor-item"></i>
            </a>
          )}
          {props?.contact?.contact?.buyerSpec?.phoneNo && (
            <a
              href={handleMobileUnregistered(
                `${props?.contact?.contact?.buyerSpec?.phoneNo}`,
              )}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-whatsapp fa-2x mr-4 mb-2 cursor-item"></i>
            </a>
          )}
          {props?.contact?.contact?.address !== null &&
            props?.contact?.contact?.buyerId && (
              <div
                className="d-inline"
                onClick={handleBuyerSpecRegistered}
                ref={buyerSpec}
                data-buyer-id={props?.contact?.contact?.buyerId}
              >
                <i className="fa fa-search fa-2x mr-4 mb-2 cursor-item"></i>
              </div>
            )}
          {props?.contact?.contact?.buyerSpec !== null &&
            props?.contact?.contact?.buyerSpecId && (
              <div
                className="d-inline"
                onClick={handleBuyerSpecUnregistered}
                ref={buyerSpec}
                data-buyer-spec-id={
                  props?.contact?.contact?.buyerSpecId
                }
              >
                <i className="fa fa-search fa-2x mr-4 mb-2 cursor-item"></i>
              </div>
            )}
            <div
              className="d-inline"
              onClick={handleBuyerProperties}
              ref={buyerSpecProperty}
              data-buyer-spec-id={props?.contact?.contact?.buyerSpecId}
              data-buyer-name={getAddressFullName(props?.contact?.contact?.address)}
              data-buyer-ref={props?.contact?.contact?.buyerRef}
              data-buyer-email={props?.contact?.contact?.address?.addressEmails[0]?.emailAddress}
            >
              <i className="fa fa-home fa-2x mr-4 mb-2 cursor-item"></i>
            </div>
        </div>
      ) : null}
    </div>
  );
};
